export interface SupportEmailContext {
  gatewayName?: string;
  gatewayUuid?: string;
  namespaceId?: string;
  namespaceName?: string;
  machineName?: string;
  machineUuid?: string;
  sourceId?: string;
  hostname?: string;
  failureStage?: string;
  failedSkill?: string;
  operationId?: string;
  failureReason?: string;
  errorMessage?: string;
  errorDetails?: Record<string, string | undefined>;
}

export class UserInfo {
  email: string;
  namespace: string;
  givenName: string;
  familyName: string;

  constructor(
    email: string,
    namespace: string,
    givenName: string,
    familyName: string,
  ) {
    this.email = email;
    this.namespace = namespace;
    this.givenName = givenName;
    this.familyName = familyName;
  }

  toString(): string {
    return (
      `Email: ${this.email}, Namespace: ${this.namespace}, ` +
      `Given Name: ${this.givenName}, Family Name: ${this.familyName}`
    );
  }
}
